export default __webpack_public_path__ + "static/media/p1.09ce4cfd.jpg";